import { Injectable } from '@angular/core';
import { WebApiService } from './web-api.service';
import { Observable } from 'rxjs';
import { IOccasionGeniusRequest } from '../types/interfaces/occasion-genius-request.interface';

@Injectable()
export class OccasionGeniusService {
  constructor(private webApiService: WebApiService) {}

  public getOccasionGeniusAll(
    cityId: string | number,
    body: IOccasionGeniusRequest,
  ): Observable<any> {
    return this.webApiService.post(`occasiongenius/all/${cityId}`, body);
  }
}
